import { NoWrap } from "../../utils/helpers";

export const useIncidentTicketSeverity = () => {
  const tableColumns = () => [
    {
      id: "month_name",
      header: "Month Name",
      filter: true,
    },
    {
      id: "open_tickets",
      header: "Open Tickets",
    },
    {
      id: "resolved_tickets",
      header: "Resolved Tickets",
    },

    {
      id: "closed_tickets",
      header: "Closed Tickets",
      filter: true,
    },
    {
      id: "total_tickets",
      header: "Total Tickets",
    },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      category_code: <NoWrap>{item?.category_code}</NoWrap>,
      category_name: <NoWrap>{item?.category_name}</NoWrap>,
      open_tickets: item?.open_tickets || 0,
      resolved_tickets: item?.resolved_tickets || 0,
      closed_tickets: item?.closed_tickets || 0,
      total_tickets: item?.total_tickets || 0,
    })) || [];

  const tableTitle = "Incident Ticket Category Report";

  return { tableData, tableColumns, tableTitle };
};
